import { useEffect, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { Message } from '@components/shared/Message'
import { useFormik } from 'formik'

/* type IEditDocument = {
    id: string
    showEditDocument: boolean
    setShowEditDocument: (showAdd: boolean) => void
    documentInfo: {
        id: string
        name: string
        collectionId?: string
    }
} */

const EditDocument = props => {
    const [, setDocument] = useState(props.documentInfo)
    const renameFileStatus = useWireValue(store.renameFileStatus)
    
    const [message, setMessage] = useState()
    
    useEffect(() => {
        if (props.documentInfo.collectionId) {
            
            // @todo wtf empty block ???
            
        }
    }, [props.documentInfo.collectionId, renameFileStatus])
    
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: props.documentInfo?.id || '',
            name: props.documentInfo?.name || '',
        },
        onSubmit: async values => {
            
            if (!values.name) {
                setMessage({ text: 'Please fill in the collection name', level: 'danger' })
            } else {
                setDocument({
                    id: values.id,
                    name: values.name,
                })
                
                // 2023-04-14 @todo
                // Editing a document name was doing nothing, so adding this here
                // This whole flow needs to be reworked though
                if (values.id && values.name)
                    await actions.updateDocumentProperties(values.id, {
                        name: values.name,
                    })
                
                props.setShowEditDocument(!props.showEditDocument)
            }
        },
    })
    const { handleSubmit, handleChange, values } = formik
    
    const handleModal = () => {
        props.setShowEditDocument(!props.showEditDocument)
    }
    
    return (
        <CustomModal open={props.showEditDocument} modalHandler={() => handleModal()} center>
            <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h2 className="modal-title">Edit document</h2>
                </div>
                <div className="modal-body">
                    {message && <Message message={message} />}
                    <div className="mb-3 form-group row flex items-center pb-4 flex justify-between">
                        <label className="col-3">Document name</label>
                        <input
                            type="text"
                            name="name"
                            className="input w-10/12"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Document name"/>
                    </div>
                </div>
                <div className="modal-footer flex justify-end">
                    <button
                        type="button"
                        className="mr-3 btn btn-primary btn-outline"
                        onClick={() => {
                            handleModal()
                        }}>
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </CustomModal>
    )
}

export default EditDocument
